import { render } from "./fcs.vue?vue&type=template&id=f87069a8&scoped=true"
import script from "./fcs.vue?vue&type=script&lang=js"
export * from "./fcs.vue?vue&type=script&lang=js"

import "./fcs.vue?vue&type=style&index=0&id=f87069a8&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87069a8"]])

export default __exports__